import axios from '../config/axiosConfig';

const API_URL = '/http-exchanges';

const getAll = async (params = {}) => {
  const response = await axios.get(API_URL, { params });
  return response.data;
};

const getById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

const replay = async (data) => {
  const response = await axios.post(`${API_URL}/replay`, data);
  return response.data;
};

const update = async (id, data) => {
  const response = await axios.put(`${API_URL}/${id}`, data);
  return response.data;
};

const remove = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

const bulkDelete = async (webTargetId) => {
  const response = await axios.delete(API_URL, { params: { webTargetId } });
  return response.data;
};

const bulkDeleteByIds = async (ids) => {
  const response = await axios.post(`${API_URL}/bulk-delete`, { ids });
  return response.data;
};

const getSiteTree = async (webTargetId, filters) => {
  const response = await axios.get(`${API_URL}/site-tree`, { params: { webTargetId, ...(filters || {}) } });
  return response.data;
};

// Create minimal exchange records for a list of {method,url} attributed to a
// profile, so they appear in the site tree.
const createStubs = async (webTargetId, urls, profileId) => {
  const response = await axios.post(`${API_URL}/stubs`, { webTargetId, urls, profileId });
  return response.data;
};

const httpExchangeService = {
  getAll,
  getById,
  replay,
  update,
  remove,
  bulkDelete,
  bulkDeleteByIds,
  getSiteTree,
  createStubs
};

export default httpExchangeService;
